var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{attrs:{"loading":_vm.loading,"headers":_vm.headers,"items":_vm.data,"sort-by":"date","sort-desc":"","mustSort":""},scopedSlots:_vm._u([{key:"item.date",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (_vm.convertDateToAmericanFormat(item.date))))+" ")]}},{key:"item.plannedDeparture",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (_vm.tConvert(item.plannedDeparture))))+" ")]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }